/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  return 5;
}

export default [
  'tg', [['AM', 'PM'], , ['пе. чо.', 'па. чо.']],
  [
    ['AM', 'PM'],
    ,
  ],
  [
    ['Я', 'Д', 'С', 'Ч', 'П', 'Ҷ', 'Ш'],
    ['Яшб', 'Дшб', 'Сшб', 'Чшб', 'Пшб', 'Ҷмъ', 'Шнб'],
    [
      'Якшанбе', 'Душанбе', 'Сешанбе', 'Чоршанбе',
      'Панҷшанбе', 'Ҷумъа', 'Шанбе'
    ],
    ['Яшб', 'Дшб', 'Сшб', 'Чшб', 'Пшб', 'Ҷмъ', 'Шнб']
  ],
  ,
  [
    ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
    [
      'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен',
      'Окт', 'Ноя', 'Дек'
    ],
    [
      'Январ', 'Феврал', 'Март', 'Апрел', 'Май', 'Июн', 'Июл',
      'Август', 'Сентябр', 'Октябр', 'Ноябр', 'Декабр'
    ]
  ],
  , [['ПеМ', 'ПаМ'], , ['Пеш аз милод', 'ПаМ']], 1, [6, 0],
  ['dd/MM/yy', 'dd MMM y', 'dd MMMM y', 'EEEE, dd MMMM y'],
  ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
  [
    '{1} {0}',
    ,
    ,
  ],
  [',', ' ', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
  ['#,##0.###', '#,##0%', '#,##0.00 ¤', '#E0'], 'сом.', 'Сомонӣ', plural
];
